import { Route } from 'react-router-dom';

import { RatePlanDetailPage } from './pages/rate-plan-detail-page.js';
import { RatePlanFormPage } from './pages/rate-plan-form-page.js';
import { RatePlanListPage } from './pages/rate-plan-list-page.js';

/**
 * The rate plan routes.
 */
export function ratePlanRoutes(): React.JSX.Element {
  return (
    <>
      <Route path="/rate-plans" element={<RatePlanListPage />} />
      <Route path="/rate-plans/new" element={<RatePlanFormPage />} />
      <Route path="/rate-plans/:ratePlanId/edit" element={<RatePlanFormPage />} />
      <Route path="/rate-plans/:ratePlanId" element={<RatePlanDetailPage />} />
    </>
  );
}
